import { localStorage_getOrNull, localStorage_set } from '../../_ui-core_/base/package/util/localStorage';

type ClickCount = Array<{
  gameId: string;
  clickCount: number;
}>;

const CLICK_COUNT_KEY = 'UserClickCount';

/**
 * Increases the click counter for a game. This is used to track which games the user has interacted with.
 */
export function increaseClickCounter(gameId: string): void {
  const clickCount = localStorage_getOrNull<ClickCount>(CLICK_COUNT_KEY) ?? [];
  const currentGame = clickCount.find((activity) => activity.gameId === gameId);
  if (currentGame) {
    currentGame.clickCount += 1;
  } else {
    clickCount.push({ gameId, clickCount: 1 });
  }
  // Limit the array to the 20 most recent games
  if (clickCount.length > 20) {
    clickCount.shift();
  }
  localStorage_set(CLICK_COUNT_KEY, clickCount);
}

export function getClickCount(): ClickCount {
  return localStorage_getOrNull<ClickCount>(CLICK_COUNT_KEY) ?? [];
}
